module.exports = __webpack_public_path__ + "img/hand-lizard.c7bad19b.svg";